import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "manage-models" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.57 5.93018L3.5 12.0002L9.57 18.0702M20.5 12.0002H3.67",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Gerenciar modelos", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "header" }
const _hoisted_6 = {
  class: "search",
  for: "search-model"
}
const _hoisted_7 = ["onKeydown"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", {
  d: "M17.5002 17.5002L13.881 13.881M13.881 13.881C14.5001 13.2619 14.9912 12.527 15.3262 11.7181C15.6612 10.9093 15.8337 10.0423 15.8337 9.16684C15.8337 8.29134 15.6612 7.42441 15.3262 6.61555C14.9912 5.80669 14.5001 5.07174 13.881 4.45267C13.2619 3.8336 12.527 3.34252 11.7181 3.00748C10.9093 2.67244 10.0423 2.5 9.16684 2.5C8.29134 2.5 7.42441 2.67244 6.61555 3.00748C5.80669 3.34252 5.07174 3.8336 4.45267 4.45267C3.2024 5.70295 2.5 7.39868 2.5 9.16684C2.5 10.935 3.2024 12.6307 4.45267 13.881C5.70295 15.1313 7.39868 15.8337 9.16684 15.8337C10.935 15.8337 12.6307 15.1313 13.881 13.881Z",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4 4L16 16",
  stroke: "#079F72",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16 4L4 16",
  stroke: "#079F72",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "filters" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V13",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M16.0399 3.01976L8.15988 10.8998C7.85988 11.1998 7.55988 11.7898 7.49988 12.2198L7.06988 15.2298C6.90988 16.3198 7.67988 17.0798 8.76988 16.9298L11.7799 16.4998C12.1999 16.4398 12.7899 16.1398 13.0999 15.8398L20.9799 7.95976C22.3399 6.59976 22.9799 5.01976 20.9799 3.01976C18.9799 1.01976 17.3999 1.65976 16.0399 3.01976Z",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M14.9102 4.1499C15.5802 6.5399 17.4502 8.4099 19.8502 9.0899",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<figure><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M9 11V17L11 15\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M9 17L7 15\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M22 10H18C15 10 14 9 14 6V2L22 10Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></figure>", 1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 0,
  class: "models"
}
const _hoisted_19 = { class: "models-title doc-grid" }
const _hoisted_20 = {
  for: "all-models",
  class: "check"
}
const _hoisted_21 = ["checked"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "13",
    height: "11",
    viewBox: "0 0 13 11",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M5.06761 9.95167C4.94632 10.0727 4.78194 10.1407 4.61057 10.1407C4.43919 10.1407 4.27482 10.0727 4.15352 9.95167L0.501349 6.2995C0.411146 6.20946 0.339583 6.10251 0.290756 5.98479C0.241929 5.86706 0.216797 5.74086 0.216797 5.61341C0.216797 5.48596 0.241929 5.35976 0.290756 5.24203C0.339583 5.1243 0.411146 5.01736 0.501349 4.92732L0.958393 4.47132C1.14038 4.2894 1.38716 4.1872 1.64448 4.1872C1.9018 4.1872 2.14858 4.2894 2.33057 4.47132L4.61057 6.74923L10.7671 0.592713C10.9491 0.410791 11.1959 0.308594 11.4532 0.308594C11.7105 0.308594 11.9573 0.410791 12.1393 0.592713L12.5963 1.04976C12.6865 1.1398 12.7581 1.24674 12.8069 1.36447C12.8557 1.48219 12.8809 1.60839 12.8809 1.73584C12.8809 1.86329 12.8557 1.98949 12.8069 2.10722C12.7581 2.22495 12.6865 2.33189 12.5963 2.42193L5.06761 9.95167Z",
      fill: "white"
    })
  ])
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Nome do modelo")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Status")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Ações")
], -1)
const _hoisted_26 = {
  key: 0,
  class: "models-full"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("path", {
  d: "M18 6L6 18",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6 6L18 18",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h1", null, "Ações em massa", -1)
const _hoisted_31 = { class: "actions" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", null, "excluir todos", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "none",
    d: "M21 5.98C17.67 5.65 14.32 5.48 10.98 5.48C9 5.48 7.02 5.58 5.04 5.78L3 5.98M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97M18.85 9.14L18.2 19.21C18.09 20.78 18 22 15.21 22H8.79C6 22 5.91 20.78 5.8 19.21L5.15 9.14M10.33 16.5H13.66M9.5 12.5H14.5",
    stroke: "#292F31",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<p>desativar todos</p><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M18.41 18.09L15.59 20.91\" stroke=\"#171717\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M18.41 20.91L15.59 18.09\" stroke=\"#171717\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M12.1601 10.87C12.0601 10.86 11.9401 10.86 11.8301 10.87C9.45006 10.79 7.56006 8.84 7.56006 6.44C7.56006 3.99 9.54006 2 12.0001 2C14.4501 2 16.4401 3.99 16.4401 6.44C16.4301 8.84 14.5401 10.79 12.1601 10.87Z\" stroke=\"#171717\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M12 21.81C10.18 21.81 8.37005 21.35 6.99005 20.43C4.57005 18.81 4.57005 16.17 6.99005 14.56C9.74005 12.72 14.25 12.72 17 14.56\" stroke=\"#171717\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 2)
const _hoisted_37 = [
  _hoisted_35
]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", null, "ativar todos", -1)
const _hoisted_39 = {
  xmlns: "http://www.w3.org/2000/svg",
  style: {"width":"13px"},
  viewBox: "0 0 13 10",
  fill: "none"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_366_3671)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.6487 9.24519C4.53246 9.36121 4.37493 9.42638 4.2107 9.42638C4.04646 9.42638 3.88894 9.36121 3.7727 9.24519L0.272696 5.74519C0.186251 5.6589 0.11767 5.55641 0.0708778 5.44359C0.0240854 5.33077 0 5.20983 0 5.08769C0 4.96555 0.0240854 4.84461 0.0708778 4.73178C0.11767 4.61896 0.186251 4.51648 0.272696 4.43019L0.710696 3.99319C0.885096 3.81885 1.1216 3.72091 1.3682 3.72091C1.61479 3.72091 1.8513 3.81885 2.0257 3.99319L4.2107 6.17619L10.1107 0.276188C10.2851 0.101846 10.5216 0.00390625 10.7682 0.00390625C11.0148 0.00390625 11.2513 0.101846 11.4257 0.276188L11.8637 0.714188C11.9501 0.800475 12.0187 0.902962 12.0655 1.01578C12.1123 1.12861 12.1364 1.24955 12.1364 1.37169C12.1364 1.49383 12.1123 1.61477 12.0655 1.72759C12.0187 1.84041 11.9501 1.9429 11.8637 2.02919L4.6487 9.24519Z",
    stroke: "none"
  })
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_366_3671" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "12.141",
      height: "9.427",
      fill: "white"
    })
  ])
], -1)
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = { class: "models-list doc-grid" }
const _hoisted_44 = ["for"]
const _hoisted_45 = ["id", "checked", "onChange"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "13",
    height: "11",
    viewBox: "0 0 13 11",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M5.06761 9.95167C4.94632 10.0727 4.78194 10.1407 4.61057 10.1407C4.43919 10.1407 4.27482 10.0727 4.15352 9.95167L0.501349 6.2995C0.411146 6.20946 0.339583 6.10251 0.290756 5.98479C0.241929 5.86706 0.216797 5.74086 0.216797 5.61341C0.216797 5.48596 0.241929 5.35976 0.290756 5.24203C0.339583 5.1243 0.411146 5.01736 0.501349 4.92732L0.958393 4.47132C1.14038 4.2894 1.38716 4.1872 1.64448 4.1872C1.9018 4.1872 2.14858 4.2894 2.33057 4.47132L4.61057 6.74923L10.7671 0.592713C10.9491 0.410791 11.1959 0.308594 11.4532 0.308594C11.7105 0.308594 11.9573 0.410791 12.1393 0.592713L12.5963 1.04976C12.6865 1.1398 12.7581 1.24674 12.8069 1.36447C12.8557 1.48219 12.8809 1.60839 12.8809 1.73584C12.8809 1.86329 12.8557 1.98949 12.8069 2.10722C12.7581 2.22495 12.6865 2.33189 12.5963 2.42193L5.06761 9.95167Z",
      fill: "white"
    })
  ])
], -1)
const _hoisted_47 = { class: "title" }
const _hoisted_48 = { class: "stats" }
const _hoisted_49 = ["checked", "onChange"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_51 = {
  for: "",
  class: "actions"
}
const _hoisted_52 = ["onClick"]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "none",
      d: "M13.2594 3.59924L5.04936 12.2892C4.73936 12.6192 4.43936 13.2692 4.37936 13.7192L4.00936 16.9592C3.87936 18.1292 4.71936 18.9292 5.87936 18.7292L9.09936 18.1792C9.54936 18.0992 10.1794 17.7692 10.4894 17.4292L18.6994 8.73924C20.1194 7.23924 20.7594 5.52924 18.5494 3.43924C16.3494 1.36924 14.6794 2.09924 13.2594 3.59924Z",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11.89 5.05078C12.0996 6.39164 12.7486 7.62492 13.735 8.55703C14.7214 9.48914 15.9894 10.0673 17.34 10.2008M3 22.0008H21",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = ["onClick"]
const _hoisted_56 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "none",
      d: "M21 5.98C17.67 5.65 14.32 5.48 10.98 5.48C9 5.48 7.02 5.58 5.04 5.78L3 5.98M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97M18.85 9.14L18.2 19.21C18.09 20.78 18 22 15.21 22H8.79C6 22 5.91 20.78 5.8 19.21L5.15 9.14M10.33 16.5H13.66M9.5 12.5H14.5",
      stroke: "#292F31",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = {
  key: 1,
  class: "no-options"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "black",
    opacity: "0.4",
    d: "M7.5013 18.3332H12.5013C16.668 18.3332 18.3346 16.6665 18.3346 12.4998V7.49984C18.3346 3.33317 16.668 1.6665 12.5013 1.6665H7.5013C3.33464 1.6665 1.66797 3.33317 1.66797 7.49984V12.4998C1.66797 16.6665 3.33464 18.3332 7.5013 18.3332Z",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "#171717",
    d: "M13.125 7.5H6.875",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "#171717",
    d: "M13.125 12.5H6.875",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("h1", null, "Sem modelos para gerenciar no momento", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.16602 1.6665H7.49935C3.33268 1.6665 1.66602 3.33317 1.66602 7.49984V12.4998C1.66602 16.6665 3.33268 18.3332 7.49935 18.3332H12.4993C16.666 18.3332 18.3327 16.6665 18.3327 12.4998V10.8332",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M13.3675 2.51688L6.80088 9.08354C6.55088 9.33354 6.30088 9.82521 6.25088 10.1835L5.89254 12.6919C5.75921 13.6002 6.40088 14.2335 7.30921 14.1085L9.81754 13.7502C10.1675 13.7002 10.6592 13.4502 10.9175 13.2002L17.4842 6.63354C18.6175 5.50021 19.1509 4.18354 17.4842 2.51688C15.8175 0.850211 14.5009 1.38354 13.3675 2.51688Z",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12.4258 3.4585C12.9841 5.45016 14.5424 7.0085 16.5424 7.57516",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("button", null, [
  /*#__PURE__*/_createElementVNode("figure", null, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M7 7L17 17M7 17L17 7",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ])
  ])
], -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "52",
  height: "52",
  viewBox: "0 0 52 52",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M42.2722 12.6747L29.4021 5.24301C27.3005 4.02967 24.7005 4.02967 22.5771 5.24301L9.72881 12.6747C7.62715 13.888 6.32715 16.1413 6.32715 18.5897V33.4097C6.32715 35.8363 7.62715 38.0897 9.72881 39.3247L22.5988 46.7563C24.7005 47.9697 27.3005 47.9697 29.4238 46.7563L42.2938 39.3247C44.3955 38.1113 45.6955 35.858 45.6955 33.4097V18.5897C45.6738 16.1413 44.3738 13.9097 42.2722 12.6747ZM24.3755 16.7913C24.3755 15.903 25.1121 15.1663 26.0005 15.1663C26.8888 15.1663 27.6255 15.903 27.6255 16.7913V28.1663C27.6255 29.0547 26.8888 29.7913 26.0005 29.7913C25.1121 29.7913 24.3755 29.0547 24.3755 28.1663V16.7913ZM27.9938 36.0313C27.8855 36.2913 27.7338 36.5297 27.5388 36.7463C27.1271 37.158 26.5855 37.3747 26.0005 37.3747C25.7188 37.3747 25.4371 37.3097 25.1771 37.2013C24.8955 37.093 24.6788 36.9413 24.4621 36.7463C24.2671 36.5297 24.1155 36.2913 23.9855 36.0313C23.8771 35.7713 23.8338 35.4897 23.8338 35.208C23.8338 34.6447 24.0505 34.0813 24.4621 33.6697C24.6788 33.4747 24.8955 33.323 25.1771 33.2147C25.9788 32.868 26.9321 33.063 27.5388 33.6697C27.7338 33.8863 27.8855 34.103 27.9938 34.3847C28.1021 34.6447 28.1671 34.9263 28.1671 35.208C28.1671 35.4897 28.1021 35.7713 27.9938 36.0313Z",
    fill: "#A30711"
  })
], -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("h1", null, "Cuidado!", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("h2", null, "Deseja mesmo deletar esse modelo?", -1)

import { onMounted, ref } from 'vue'
import { AxiosResponse } from 'axios'
import ModelInterface from '@/models/ModelInterface'
import { useAxios } from '@/api/axios'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'
import ModelStatusEnum from '@/enums/ModelStatusEnum'
import MyModal from '@/components/modal/MyModal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ManageModelsView',
  setup(__props) {

const axios = useAxios()
const models = ref<ModelInterface[]>()
const selectedModels = ref<ModelInterface[]>([])
const filter = ref<Record<string, string>>({})
const isMobileOptionsFilterOpen = ref<boolean>(false)

const isConfirmDeleteModal = ref<boolean>(false)
const modelToDeleteId = ref<number>(0)

const toggleOverflow = () => {
  isMobileOptionsFilterOpen.value = !isMobileOptionsFilterOpen.value
  document.body.style.overflow = isMobileOptionsFilterOpen.value ? 'hidden' : 'auto'
}

function getModels () {
  models.value = undefined

  axios.get('/api/models', { params: filter.value })
    .then((res: AxiosResponse<ModelInterface[]>) => {
      models.value = res.data
    })
}

function updateModelStatus (ids: number[], status: ModelStatusEnum) {
  const modelsValue = models.value
  // models.value = undefined
  selectedModels.value = []

  ids.forEach((id) => {
    const orgIndex = modelsValue!.findIndex((org) => org.id == id)
    modelsValue![orgIndex].status = status
  })

  axios.patch('/api/models', { model_ids: ids, status: status })
    .then((res: AxiosResponse<ModelInterface[]>) => {
      models.value = res.data
      models.value = modelsValue
    })
}

function deleteModel (ids: number[]) {
  models.value = models.value?.filter(m => !ids.includes(m.id))
  const modelsValue = models.value
  models.value = undefined

  axios.delete('/api/models', { model_ids: ids })
    .then(() => {
      models.value = modelsValue
      selectedModels.value = []
    })
}

onMounted(() => {
  getModels()
})

function downloadFiles (models: DocumentModel[]): void {
  models.forEach((model) => {
    model.files.forEach((file) => {
      axios.get(`/api/models/get-file-content/${file.id}`, { responseType: 'blob' })
        .then(response => {
          const url = URL.createObjectURL(new Blob([response.data]))

          const link = window.document.createElement('a')
          link.href = url
          link.setAttribute('download', file.name)
          link.style.display = 'none'
          window.document.body.appendChild(link)
          link.click()
          window.document.body.removeChild(link)
        })
        .catch(error => {
          console.error('Erro ao buscar o documento:', error)
        })
    })
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/admin/home'))),
      class: "back"
    }, _hoisted_4),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          autocomplete: "off",
          type: "text",
          placeholder: "Digite sua busca",
          id: "search-model",
          name: "search-model",
          onKeydown: _withKeys(_withModifiers(getModels, ["prevent"]), ["enter"]),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filter.value.search) = $event))
        }, null, 40, _hoisted_7), [
          [_vModelText, filter.value.search]
        ]),
        (!filter.value.search)
          ? (_openBlock(), _createElementBlock("svg", {
              key: 0,
              onClick: getModels,
              xmlns: "http://www.w3.org/2000/svg",
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "none"
            }, _hoisted_9))
          : (_openBlock(), _createElementBlock("svg", {
              key: 1,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (filter.value.search = '')),
              xmlns: "http://www.w3.org/2000/svg",
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "none"
            }, _hoisted_12))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("button", {
          class: "tooltip",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/admin/create-models')))
        }, _hoisted_15),
        (models.value?.length)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "tooltip",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (downloadFiles(models.value)))
            }, _hoisted_17))
          : _createCommentVNode("", true)
      ])
    ]),
    (models.value && models.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("label", _hoisted_20, [
              _createElementVNode("input", {
                type: "checkbox",
                name: "all-models",
                id: "all-models",
                checked: selectedModels.value.length == models.value.length,
                onChange: _cache[5] || (_cache[5] = ($event: any) => (($event.target as HTMLInputElement).checked ? selectedModels.value = models.value : selectedModels.value = []))
              }, null, 40, _hoisted_21),
              _hoisted_22
            ]),
            _hoisted_23,
            _hoisted_24,
            _hoisted_25
          ]),
          (selectedModels.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                (_openBlock(), _createElementBlock("svg", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => {selectedModels.value = [];}),
                  class: "close",
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none"
                }, _hoisted_29)),
                _hoisted_30,
                _createElementVNode("h2", null, [
                  _createElementVNode("strong", null, _toDisplayString(selectedModels.value.length) + " itens foram selecionados", 1),
                  _createTextVNode(", oque deseja fazer com todos eles?")
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (deleteModel(selectedModels.value.map((m) => m.id))))
                  }, _hoisted_34),
                  _createElementVNode("div", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (updateModelStatus(selectedModels.value.map((m) => m.id), _unref(ModelStatusEnum).INACTIVE)))
                  }, _hoisted_37),
                  _createElementVNode("div", {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (updateModelStatus(selectedModels.value.map((m) => m.id), _unref(ModelStatusEnum).ACTIVE)))
                  }, [
                    _hoisted_38,
                    (_openBlock(), _createElementBlock("svg", _hoisted_39, _hoisted_42))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(models.value, (model) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_43, [
              _createElementVNode("label", {
                for: `model-${model.id}`,
                class: "check"
              }, [
                _createElementVNode("input", {
                  type: "checkbox",
                  name: "docs",
                  id: `model-${model.id}`,
                  checked: selectedModels.value.find((m) => m.id == model.id) ? true : false,
                  onChange: ($event: any) => (selectedModels.value.find((m) => m.id == model.id) ? (selectedModels.value = selectedModels.value.filter((m) => model.id != m.id)) : selectedModels.value.push(model))
                }, null, 40, _hoisted_45),
                _hoisted_46
              ], 8, _hoisted_44),
              _createElementVNode("label", _hoisted_47, [
                _createElementVNode("h1", null, _toDisplayString(model.name), 1)
              ]),
              _createElementVNode("label", _hoisted_48, [
                _createElementVNode("input", {
                  type: "checkbox",
                  checked: model.status == 'active',
                  onChange: ($event: any) => (($event.target as HTMLInputElement).checked ? updateModelStatus([model.id], _unref(ModelStatusEnum).ACTIVE) : updateModelStatus([model.id], _unref(ModelStatusEnum).INACTIVE))
                }, null, 40, _hoisted_49),
                _hoisted_50
              ]),
              _createElementVNode("label", _hoisted_51, [
                _createElementVNode("button", {
                  class: "tooltip",
                  onClick: ($event: any) => (_ctx.$router.push({ name: 'admin.models.edit', params: { id: model.id } }))
                }, _hoisted_54, 8, _hoisted_52),
                _createElementVNode("button", {
                  class: "tooltip",
                  onClick: ($event: any) => {isConfirmDeleteModal.value = true; modelToDeleteId.value = model.id;}
                }, _hoisted_57, 8, _hoisted_55)
              ])
            ]))
          }), 256))
        ]))
      : (models.value && !models.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
            _hoisted_59,
            _hoisted_60,
            _createElementVNode("p", null, [
              _createElementVNode("a", {
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$router.push('/admin/create-models')))
              }, "Clique aqui"),
              _createTextVNode(" para cadastrar")
            ])
          ]))
        : (_openBlock(), _createBlock(SpinnerLoader, { key: 2 })),
    _createElementVNode("nav", {
      class: _normalizeClass([{active: isMobileOptionsFilterOpen.value}, "action-filters"]),
      onClick: toggleOverflow
    }, [
      _createElementVNode("button", {
        onClick: [
          _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"])),
          _cache[12] || (_cache[12] = ($event: any) => {toggleOverflow(); _ctx.$router.push('/admin/create-models');})
        ]
      }, _hoisted_62),
      _hoisted_63
    ], 2),
    _createVNode(MyModal, {
      width: '330px !important',
      height: '260px !important',
      isOpen: isConfirmDeleteModal.value,
      "class-name": 'confirm-delete',
      toggleModal: (v) => isConfirmDeleteModal.value = v,
      zIndex: 100
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_64,
          _hoisted_65,
          _hoisted_66,
          _createElementVNode("section", null, [
            _createElementVNode("button", {
              onClick: _cache[13] || (_cache[13] = ($event: any) => {isConfirmDeleteModal.value = false; deleteModel([modelToDeleteId.value]);})
            }, "Sim"),
            _createElementVNode("input", {
              autocomplete: "off",
              onClick: _cache[14] || (_cache[14] = ($event: any) => {isConfirmDeleteModal.value = false;}),
              type: "button",
              value: "Cancelar"
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["isOpen", "toggleModal"])
  ]))
}
}

})